import EventClass from "common/utils/ui/event-class";

export default class MobileMenuVisibilityClass extends EventClass {
  #props = {};

  #isOpenModal = false;

  #closeMenuClassName = "hidden";

  #lockedDocumentScrollClassName = "locked-mobile";

  constructor(props) {
    super(props);
    this.#props = props;
  }

  get #$menuWrapper() {
    return document.querySelector(this.#props.menuWrapperSelector);
  }

  event(event, target) {
    super.event(event, target);

    if (this.#isOpenModal) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }

  closeModal() {
    this.#$menuWrapper.classList.add(this.#closeMenuClassName);
    document.documentElement.classList.remove(this.#lockedDocumentScrollClassName);
    this.#isOpenModal = false;
  }

  openModal() {
    document.documentElement.style.setProperty("--window-inner-height", `${window.innerHeight}px`);
    this.#$menuWrapper.classList.remove(this.#closeMenuClassName);
    document.documentElement.classList.add(this.#lockedDocumentScrollClassName);
    this.#isOpenModal = true;
  }
}
